import { useState } from 'react';
import { checkCurrentUnion, confirmUnionTransfer } from '../api/currentUnionApi.js';
import { resetUnionSession } from '../../../shared/browser/unionSessionBoundary.js';

export function CurrentUnionSettings({ entry, embedded = false }) {
  const [proposal, setProposal] = useState(null);
  const [working, setWorking] = useState('');
  const [error, setError] = useState('');
  async function check() {
    setWorking('check'); setError(''); setProposal(null);
    try {
      setProposal(await checkCurrentUnion());
      window.dispatchEvent(new CustomEvent('dororaid:game-profile-changed'));
    }
    catch (error) { setError(error.message); }
    finally { setWorking(''); }
  }
  async function confirm() {
    setWorking('confirm'); setError('');
    try {
      await confirmUnionTransfer(proposal.id);
      resetUnionSession('confirmed-transfer', entry.profile.user_id);
    } catch (error) { setError(error.message); setWorking(''); }
  }
  const blocked = proposal?.requiresLeadershipTransfer || ['pending', 'suspended'].includes(proposal?.targetStatus);
  return <section className="my-info-union-settings" aria-label="BlablaLink 정보 갱신">
    {!embedded ? <header className="my-info-heading"><h1>BlablaLink 정보</h1></header> : null}
    {!embedded || (proposal && !proposal.sameUnion) ? <div className="my-info-summary">
      <article><span>사이트 소속</span><strong>{entry?.union?.name || '소속 없음'}</strong></article>
      {proposal ? <article><span>게임 소속</span><strong>{proposal.guildName}</strong></article> : null}
    </div> : null}
    <div className="my-info-union-actions"><button type="button" disabled={Boolean(working)} onClick={check}>{working === 'check' ? '정보 갱신 중…' : 'BlablaLink 정보 갱신'}</button></div>
    {proposal ? <div className="my-info-union-result" role="status">
      {proposal.sameUnion ? <p>프로필 정보를 갱신했습니다.</p>
        : proposal.requiresLeadershipTransfer ? <p>멤버 관리에서 주딱을 위임한 뒤 다시 확인해주세요.</p>
          : blocked ? <p>새 유니온이 승인 대기 또는 이용 정지 상태입니다.</p>
            : <><p>이전 기록은 기존 유니온에 남으며, 관리 권한은 이전되지 않습니다.</p>
              {proposal.targetStatus === 'unregistered' ? <p>전환 후 새 유니온 등록을 진행합니다.</p> : null}
              <div className="my-info-union-actions"><button type="button" className="primary" disabled={Boolean(working)} onClick={confirm}>{working === 'confirm' ? '전환 중…' : '소속 전환'}</button><button type="button" disabled={Boolean(working)} onClick={() => setProposal(null)}>취소</button></div></>}
    </div> : null}
    {error ? <p className="my-info-union-error" role="alert">{error}</p> : null}
  </section>;
}
